export const DATA_FILTER_TYPES = ['Data exata: ', 'Data posterior a', 'Data anterior a', 'Intervalo de datas']
